module.exports = __webpack_public_path__ + "img/service-supply.d9d4143.png";